import { action } from 'typesafe-actions'
import { CmsActionTypes } from './types'

export const getCmsPDFRequest = () => action(CmsActionTypes.GET_CMS_PDF_REQUEST)

export const getCmsPDFSuccess = () => action(CmsActionTypes.GET_CMS_PDF_SUCCESS)

export const getCmsPDFFail = (message: string) =>
  action(CmsActionTypes.GET_CMS_PDF_FAIL, message)